// extracted by mini-css-extract-plugin
export default {"container":"TextBlock_container__PtM5L","title":"TextBlock_title__F14qN","paragraph":"TextBlock_paragraph__rQ43Z"};